<template>
  <div>
    <ContentPage headerText="Jean Wilcox">
      <p>

      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
            <div class="section">
              <div>
                <p>
                  Jean is a fully comprehensive Pilates teacher. Qualified 2011 Jean has continued to be very active within the Pilates world. Jean had trained and worked with some brilliant Pilates teachers and continues her studies after moving the family home to the UK in 2016 spending two years settling my Children into a new education system preparing for GCSE and making a new life for the family for my husband's work. I opened Pilates Haven 2018. <br/>

                  Fully comprehensive trained through MBodies Academy Oxford and the following: </p>

                <ul>
                  <li>Anatomy in Motion</li>
                  <li>Pilates Performance Dublin</li>
                  <li>Pilates for Midlife male and female</li>
                  <li>Male Pelvic System</li>
                  <li>Scoliosis Specialist</li>
                  <li>Pilates for Pregnancy</li>
                  <li>Pilates for the Blind</li>
                  <li>Pilates for Bone Health</li>
                  <li>Teacher to the Teachers</li>
                  <li>Female Pelvic Specialist</li>
                </ul>
                <p>
                  Having founded Pilates Haven in 2018 opening the first fully equipped Pilates studio in the area Jean has grown the Pilates studio on the East Coast sharing her Pilates Passion.
                </p>
                <p>
                  Pilates to be accessible to everyone through the apparatus, we now have grown the studio to three times the floor space with the bold Move to Beccles town center during spring 2024 we can now offer a specialized mat room with extensive small equipment, along with a reformer room and the private large apparatus room for circuit classes and Private sessions. We are a gold Align Studio.
                </p>
                <p>
                  We have also developed a fully comprehensive training system which is fully operational from Pilates Haven Jean recognized having to always travel from the East Coast to London, Scotland Ireland, and even the US for training we needed an accessible training package to allow cost-effective training, we are growing the Pilates community from within the studio to allow new teachers to grow work within the studio or away from the studio but always having the Pilates Haven door open to all teachers of all levels and Disciplines, powered by Pilates Education Institute.
                </p>
                <p>
                  I am very proud of the studio and what we offer to everyone, I have a grown family which allows me the time to apply fully to my passion for Pilates which comes out in the studio, along with traveling with my Husband when we get the opportunity away from our busy working lives, The door is open to all fitness levels, all ages and genders.
                </p>
                <p>
                  We look forward to welcoming you into the studio x
                </p>

              </div>

              <div>
                <img
                  class="image-card-img"
                  src="/images/AboutPage.jpg"
                  alt="Jean Wilcox"
                />
              </div>
            </div>

          <div class="section">
            <h2>Visit Us Today</h2>
            <p>
              We invite you to experience the difference at Pilates Haven’s.
            </p>
            <p>
              <router-link to="/contact-us/" class="underline">
                Contact Us</router-link
              >
              to book an appointment or learn more about our services.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'about-us',
  components: {
    ContentPage
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;
}

.section {
  $gutter: 2rem;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: space-between;
  gap: $gutter;

  h2 {
    font-size: 2rem;
    margin-bottom: $gutter;
  }

  img {
    height: auto;
  }

  @media (min-width: $md-breakpoint) {
    gap: 4rem;
    flex-direction: row;

    > * {
      flex: 1;
    }

    &:nth-child(2n) {
      div:first-of-type {
        order: 2;
      }

      .image-card {
        order: 1;
      }
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 30px;
  column-gap: 20px;

  li {
    width: 100%;

    @media (min-width: $xs-breakpoint) {
      width: 50%;
    }

    @media (min-width: $sm-md-breakpoint) {
      width: 33.33%;
    }

    @media (min-width: $md-breakpoint) {
      width: calc(33.33% - 20px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue